<template>
  <thead>
    <tr>
      <th class="px-4 py-2 font-medium text-sm whitespace-nowrap border border-gray-400">
        <input type="checkbox" :disabled="disabled" v-model="selectAll" />
      </th>
      <th class="px-4 py-3 font-medium text-sm w-full border border-gray-400" />
      <th
        v-for="notificationChannel in notificationChannels"
        :key="notificationChannel.code"
        class="px-4 py-2 font-medium text-sm whitespace-nowrap border border-gray-400"
        :style="{ minWidth: '5rem' }"
      >
        <portal-target :name="`channel:${notificationChannel.code}`" />
      </th>
    </tr>
    <tr>
      <th class="px-4 py-2 font-medium text-sm whitespace-nowrap border border-gray-400">&nbsp;</th>
      <th class="px-4 py-3 font-medium text-sm text-left w-full border border-gray-400">
        Notification type
      </th>
      <TableHeaderColumn
        v-for="notificationChannel in notificationChannels"
        :key="notificationChannel.code"
        :notification-channel="notificationChannel"
        :user-notification-settings="userNotificationSettings"
        :disabled="disabled"
      />
    </tr>
  </thead>
</template>

<script>
import TableHeaderColumn from './TableHeaderColumn.vue';

export default {
  name: 'TableHeader',
  components: { TableHeaderColumn },
  props: {
    notificationChannels: { type: Array, required: true },
    userNotificationSettings: { type: Array, required: true },
    disabled: Boolean,
  },
  computed: {
    selected() {
      return this.userNotificationSettings.filter((x) => x.isEnabled);
    },
    selectAll: {
      get() {
        return this.selected.length === this.userNotificationSettings.length;
      },
      set(select) {
        this.userNotificationSettings.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.isEnabled = select;
        });
      },
    },
  },
};
</script>
